export function modal(state, action) {
    switch (action.type) {
      case "SET_MODAL_ID":
        return { ...state, modal: action.payload };
      default:
        return state;
    }
  }